import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/capital-account';

export const findAllAccounts = () => get(BASE);
export const createAccount = (body) => post(BASE, body);
export const updateAccount = (id, body) => put(`${BASE}/${id}`, body);
export const deleteAccount = (id) => del(`${BASE}/${id}`);